import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { EQUIPMENT_SEARCH_LIMIT } from '@brokerportal/common/utils/equipment-search';
import {
    HESLP_SOLAR_WATER_HEATER_SEARCH_PRODUCT,
    SolarWaterHeaterSearchResponse
} from '@brokerportal/common/models/application/solar-water-heater-reference-data.model';

/**
 * ESC-approved solar water heater search (ESC-130/ESC-131). Mirrors `HeatPumpReferenceDataService`: the endpoint
 * is HESLP-scoped, so `product=HESLP` is always sent and there is no unfiltered variant to fall back to.
 */
@Injectable({ providedIn: 'root' })
export class SolarWaterHeaterReferenceDataService {
    private readonly baseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.useDirectQuoteService ? environment.quoteServiceHost : environment.api.baseUrl;
    }

    searchSolarWaterHeaters(query: string, limit = EQUIPMENT_SEARCH_LIMIT): Observable<SolarWaterHeaterSearchResponse> {
        const params = new HttpParams()
            .set('search', query)
            .set('limit', String(limit))
            .set('product', HESLP_SOLAR_WATER_HEATER_SEARCH_PRODUCT);
        return this.httpClient.get<SolarWaterHeaterSearchResponse>(
            `${this.baseUrl}/${environment.referenceDataRoute}/solar-water-heaters`,
            { params }
        );
    }
}
